import { Helmet } from "react-helmet-async";

interface SeoProps {
  title?: string;
  description?: string;
  path?: string;
  image?: string;
  type?: "website" | "article";
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

const SITE = "https://www.thefloor.pro";
const DEFAULT_TITLE = "The Floor — Sovereign AI Speech & Debate Platform for Leaders";
const DEFAULT_DESC =
  "The Floor is the sovereign AI platform for presidents, politicians, and executives to rehearse speeches, run live debates, and master public discourse with real-time coaching.";
const DEFAULT_IMAGE =
  "https://storage.googleapis.com/gpt-engineer-file-uploads/oyvwSAD8u8WioHhQVwoPlREi6c63/social-images/social-1777211236954-THE_FLOOR_LOGO2.webp";

/**
 * Sitewide SEO defaults — drop into any route to override per-page.
 * Falls back to the app-level tags baked into index.html.
 */
const Seo = ({ title, description, path = "/", image, type = "website", jsonLd }: SeoProps) => {
  const fullTitle = title
    ? title.includes("The Floor")
      ? title
      : `${title} — The Floor`
    : DEFAULT_TITLE;
  const desc = description ?? DEFAULT_DESC;
  const url = `${SITE}${path.startsWith("/") ? path : `/${path}`}`;
  const img = image ?? DEFAULT_IMAGE;
  const schemas = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
};

export default Seo;